<div autofocus tabindex="0" id="menu-profile-container">
    <div [hidden]="isSwitchGroupDisplayed" (keyup.escape)="close()" trapFocus>
        <ng-container [ngTemplateOutlet]="menuProfile"> </ng-container>
    </div>
</div>

<ng-template #menuProfile>
    <ul id="menu-profile">
        <li id="account-settings-item">
            <a [href]="accountSettingsUrl" target="_blank" id="account-settings-link">
                <button id="account-settings" tabindex="-1">
                    <div class="btn-icon" id="account-settings-icon">
                        <i class="fa-light fa-user-gear"></i>
                    </div>
                    <label for="account-settings-icon" id="account-settings-label">{{
                        'profileMenu.accountSettings' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="quickorder-settings-item">
            <a [href]="quickorderSettingsUrl" target="_blank" id="quickorder-settings-link">
                <button id="quickorder-settings" tabindex="-1">
                    <div class="btn-icon" id="quickorder-settings-icon">
                        <i class="fa-light fa-file-invoice-dollar"></i>
                    </div>
                    <label for="billing-settings-icon" id="quickorder-settings-label">{{
                        'profileMenu.quickorderSettings' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="billing-settings-item">
            <a [href]="billingSettingsUrl" target="_blank" id="billing-settings-link">
                <button id="billing-settings" tabindex="-1">
                    <div class="btn-icon" id="billing-settings-icon">
                        <i class="fa-light fa-file-invoice-dollar"></i>
                    </div>
                    <label for="billing-settings-icon" id="billing-settings-label">{{
                        'profileMenu.billingSettings' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="message-settings-item">
            <a [href]="messageSettingsUrl" target="_blank" id="message-settings-link">
                <button id="message-settings" tabindex="-1">
                    <div class="btn-icon" id="message-settings-icon">
                        <i class="fa-light fa-message-lines"></i>
                    </div>
                    <label for="message-settings-icon" id="message-settings-label">{{
                        'profileMenu.messageSettings' | translate
                    }}</label>
                </button>
            </a>
        </li>
        <li id="sign-out-item">
            <button id="sign-out-link" (click)="logout()">
                <div class="btn-icon" id="sign-out-icon">
                    <i class="fa-light fa-right-from-bracket"></i>
                </div>
                <label for="sign-out-icon" id="sign-out-label">{{ 'profileMenu.signOut' | translate }}</label>
            </button>
        </li>
    </ul>
</ng-template>
